import React from 'react';
import { RichTextBlock } from 'prismic-reactjs';
import { ImageProps } from '@components/image';
import Text from '@components/text';
import Wrapper from '@components/wrapper.styled';
import generateId from '@helpers/generate-id';
import Section from '@components/section';
import getLinkConfig, { LinkConfigType } from '@helpers/get-link-config';
import {
  ImageContainer,
  Container,
  StyledLink,
  StyledGrid,
  StyledImage,
  TextContainer,
} from './promotions.styled';

const PromotionsIdGenerator = generateId();

export interface PromotionsProps {
  items: PromotionsPropsItem[];
  itemsPerRow?: number;
  enclosedContainer?: boolean;
  alignment?: boolean;
}

export interface PromotionsPropsItem {
  image?: ImageProps;
  title?: {
    text: string;
  };
  description?: {
    richText: RichTextBlock[];
  };
  link_label?: string;
  link?: {
    url?: string;
    uid?: string;
  };
}

const Promotions = ({
  items,
  itemsPerRow = 3,
  enclosedContainer,
  alignment,
}: PromotionsProps): JSX.Element => {
  const onLinkClick = (e: React.MouseEvent<HTMLDivElement>, { url }: LinkConfigType) => {
    e.stopPropagation();

    if (url) {
      window.open(url, '_self');
    }
  };

  return (
    <Section backgroundColor="white">
      <Wrapper>
        <StyledGrid itemsPerRow={itemsPerRow}>
          {items?.map(({ image, title, description, link_label, link }) => {
            const linkConfig = getLinkConfig(link);

            return (
              <Container
                key={PromotionsIdGenerator.next().value}
                isLink={!!linkConfig.url}
                onClick={(e) => onLinkClick(e, linkConfig)}
                $enclosedContainer={enclosedContainer}
              >
                {image?.url && (
                  <ImageContainer>
                    <StyledImage url={image?.url} alt={image?.alt || ''} />
                  </ImageContainer>
                )}
                <TextContainer $alignment={alignment}>
                  {title?.text && (
                    <Text
                      tag="h3"
                      fontColor="black"
                      type="title"
                      fontSize="heading5"
                      stringText={title.text}
                      margin="none"
                    />
                  )}
                  {description?.richText && description?.richText.length > 0 && (
                    <Text
                      type="description"
                      richText={description?.richText}
                      fontSize="body"
                      fontColor="dark"
                      margin="none"
                    />
                  )}
                  {linkConfig.url && (
                    <StyledLink
                      title={link_label || 'Learn more'}
                      url={linkConfig.url}
                      fontColor="secondary"
                      isExternal={linkConfig.isExternal}
                      type="text"
                    />
                  )}
                </TextContainer>
              </Container>
            );
          })}
        </StyledGrid>
      </Wrapper>
    </Section>
  );
};

export default Promotions;
